import React, { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { authClient } from "@lib/okta";
import { Loader } from "@components/Loader";
import { buildPreviewHandoffState } from "@utils/previewLoginHandoff";

/**
 * Popup entry point (a top-level window, where Okta renders normally) for the editor preview
 * login. It starts the normal Okta redirect, carrying the handoff nonce in the Okta `state`
 * param so the callback can reliably recognise the popup on return (see previewLoginHandoff).
 * Okta returns to `/login/callback`, where PreviewLoginRelay hands the tokens back to the
 * opener iframe.
 */
export const PreviewLogin: React.FC = () => {
  const [searchParams] = useSearchParams();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const nonce = searchParams.get("nonce") ?? "";
    void authClient.signInWithRedirect({ state: buildPreviewHandoffState(nonce) });
  }, [searchParams]);

  return (
    <div className="flex h-screen items-center justify-center">
      <Loader />
    </div>
  );
};
